import React from "react"
import FormattedMessage, {injectIntl} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import TimezoneSelect, {allTimezones} from "react-timezone-select"
import Spacing from "@irati/ui/src/Spacing"

interface Props {
  value: string
  onChange: (value: string) => void
}
const TimezonesSelect: React.FC<Props> = (props) => {
  const {value, onChange} = props
  const options = Object.keys(allTimezones).map((item) => ({label: item, value: item}))
  const handleChange = (timezone) => {
    onChange(timezone.value)
  }
  return (
    <Spacing marginTop>
      <TimezoneSelect
        value={value}
        options={options}
        onChange={handleChange}
        isSearchable={false}
        components={{
          SingleValue: () => <FormattedMessage id="recognition.create.timezoneLabel" values={{timezone: value}} />,
          IndicatorSeparator: () => null,
          IndicatorContainer: ({children}) => children,
          Control: ({children, innerProps}) => (
            <Flex {...innerProps} alignItems="center" width="fit-content">
              <Icon icon={IconTypes.countries} marginRight large />
              {children}
            </Flex>
          ),
          ValueContainer: ({children}) => children
        }}
      />
    </Spacing>
  )
}
export default injectIntl(TimezonesSelect)
